export const STORE_RESET_ALL = 'STORE_RESET_ALL'

export const STORE_STATUS_ERROR = 'error'
export const STORE_STATUS_LOADING = 'loading'
export const STORE_STATUS_FINISHED = 'finished'
export const STORE_STATUS_INITIALIZED = 'initialized'

export const STORE_INVOICE = 'invoice'
export const STORE_INVOICE_ATTACH_FILE = `${STORE_INVOICE}/attachFile`

export const STORE_INVOICE_PREVIEW = 'invoicePreview'
export const STORE_INVOICE_FETCH_PREVIEW_MERCHANT = `${STORE_INVOICE_PREVIEW}/fetchPreviewMerchant`

export const STORE_AUTH = 'auth'
export const STORE_AUTH_FETCH_USER = `${STORE_AUTH}/fetchUser`
export const STORE_AUTH_VERIFY_ACCESS = `${STORE_AUTH}/verifyAccess`
export const STORE_AUTH_FETCH_UPDATE_PASSWORD = `${STORE_AUTH}/fetchUpdatePassword`

export const STORE_OWNERS = `${STORE_AUTH}/owners`
export const STORE_OWNERS_FETCH_LIST = `${STORE_AUTH}/fetchList`

export const STORE_USER = 'user'
export const STORE_USER_FETCH_BY_TOKEN = `${STORE_USER}/fetchByToken`
export const STORE_USER_FETCH_SELF_PHOTO = `${STORE_USER}/fetchSelfPhoto`
export const STORE_USER_FETCH_FRONT_DOCUMENT_PHOTO = `${STORE_USER}/fetchFrontDocumentPhoto`
export const STORE_USER_FETCH_BACK_DOCUMENT_PHOTO = `${STORE_USER}/fetchBackDocumentPhoto`
export const STORE_USER_FETCH_CAMERA_RESOURCES = `${STORE_USER}/fetchCameraResources`

export const STORE_USER_SITUATION = 'user-situation'
export const STORE_USER_FETCH_SITUATION = `${STORE_USER}/fetchSituation`

export const STORE_USER_DOCUMENTS = 'user-documents'
export const STORE_USER_DOCUMENTS_REQUIRED_FETCH = `${STORE_USER_DOCUMENTS}/fetchRequiredDocuments`

export const STORE_PHONE = 'phone'

export const STORE_COMPANY = 'company'
export const STORE_COMPANY_FETCH_LIST = `${STORE_COMPANY}/fetchList`

export const STORE_LEGAL_PERSON = 'legalPerson'
export const STORE_LEGAL_PERSON_FETCH = `${STORE_LEGAL_PERSON}/fetch`

export const STORE_LEGAL_PERSON_UPLOAD = 'legalPerson'
export const STORE_LEGAL_PERSON_UPLOAD_LIST_FILES = `${STORE_LEGAL_PERSON_UPLOAD}/ListFiles`
export const STORE_LEGAL_PERSON_FINISH_UPLOAD = `${STORE_LEGAL_PERSON_UPLOAD}/finishUpload`

export const STORE_COMMERCIAL_RELATIONSHIP = 'commercialRelationship'
export const STORE_COMMERCIAL_RELATIONSHIP_FETCH_MERCHANTS = `${STORE_COMMERCIAL_RELATIONSHIP}/fetchMerchants`

export const STORE_BUYER = 'buyer'
export const STORE_BUYER_FETCH_SELLERS = `${STORE_BUYER}/fetchSellers`

export const STORE_POLICY = 'policy'
export const STORE_FETCH_CONTRACT = `${STORE_POLICY}/fetchContract`

export const STORE_NOTIFICATION = 'notification'
export const STORE_NOTIFICATION_FETCH_BADGE = `${STORE_NOTIFICATION}/fetchList`
export const STORE_NOTIFICATION_FETCH_ALERT = `${STORE_NOTIFICATION}/fetchAlert`

export const STORE_NOTIFICATION_CENTRAL = 'notification-central'
export const STORE_NOTIFICATION_CENTRAL_FETCH = `${STORE_NOTIFICATION_CENTRAL}/fetchList`
export const STORE_NOTIFICATION_CENTRAL_FETCH_STATUS = `${STORE_NOTIFICATION_CENTRAL}/fetchStatus`

export const STORE_BILL = 'bill'
export const STORE_BILL_FETCH = `${STORE_BILL}/fetchList`
export const STORE_BILL_REFUND_BALANCE = `${STORE_BILL}/refundBalance`

export const STORE_BILL_CURRENT = 'bill-current'
export const STORE_BILL_CURRENT_FETCH = `${STORE_BILL}/fetchCurrent`

export const STORE_BILL_PREVIEW_LINE_ITEM = 'bill-preview-line-item'
export const STORE_BILL_PREVIEW_LINE_ITEM_FETCH = `${STORE_BILL}/fetchPreviewLineItem`

export const STORE_TUTORIAL = 'tutorial'
export const STORE_TUTORIAL_FETCH_LIST = `${STORE_TUTORIAL}/fetchList`

export const STORE_QUIZ = 'quiz'
export const STORE_QUIZ_FETCH_QUESTIONS = `${STORE_QUIZ}/fetchQuestions`

export const STORE_CHECKOUT_PAYMENT = 'checkoutPayment'
export const STORE_CHECKOUT_PURCHASE_INTENTION = `${STORE_CHECKOUT_PAYMENT}/purchaseIntention`
export const STORE_RESERVATION = `${STORE_CHECKOUT_PAYMENT}/reservation`

export const STORE_CONTRACT = 'contract'
export const STORE_CONTRACT_COLLECTING = `${STORE_CONTRACT}/status`

export const STORE_PAYMENT = 'payment'
export const STORE_PAYMENT_LIST_PAYMENT_LINKS = `${STORE_PAYMENT}/listPaymentLinks`
export const STORE_PAYMENT_LIST_PAGINATED_PAYMENT_LINKS = `${STORE_PAYMENT}/listPaginatedPaymentLinks`

export const STORE_TRIAL = 'trial'
export const STORE_TRIAL_MERCHANT_IS_ABLE_TO_TRANSACT = `${STORE_TRIAL}/merchantIsAbleToTransact`

export const STORE_SINGLE_PLAYER = 'singlePlayer'
export const STORE_SINGLE_PLAYER_BOLETO_BLOB = `${STORE_TRIAL}/boletoBlob`

export const STORE_OBLIGATION = 'obligation'
export const STORE_OBLIGATION_FETCH = `${STORE_OBLIGATION}/fetch`

export const STORE_SIDEBAR = 'sidebar'
